import { useState, useEffect } from 'react';
import { getMessageGroupById } from '../data/MessageData';

interface UseGroupInfoReturn {
  groupName: string | null;
  loading: boolean;
  error: string | null;
}

export const useGroupInfo = (groupId: string): UseGroupInfoReturn => {
  const [groupName, setGroupName] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!groupId) {
      setGroupName(null);
      setLoading(false);
      return;
    }

    const fetchGroupInfo = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const groupData = await getMessageGroupById(groupId);
        
        if (groupData) {
          // Check for common group name fields
          const name = groupData.name || 
                      groupData.title || 
                      groupData.groupName || 
                      groupData.displayName ||
                      `Chat Group ${groupId.slice(-6)}`;
          setGroupName(name);
        } else {
          setGroupName(`Chat Group ${groupId.slice(-6)}`);
        }
      } catch (err) {
        console.error('Error fetching group info:', err);
        setError('Failed to load group info');
        setGroupName(`Chat Group ${groupId.slice(-6)}`);
      } finally {
        setLoading(false);
      }
    };

    fetchGroupInfo();
  }, [groupId]);

  return { groupName, loading, error };
};
